import style from "./FilterBoxes.module.css"; //
import React, { ChangeEvent, useState } from "react"; //
import { useTranslation } from "react-i18next"; //
import checkedIcon from "../../../../base/assets/icons/checkbox_full.png";

interface ItemDI {
  name: string;
  id: number | string;
  count: number;
}

interface FilterBoxesPropsDI {
  items: Array<ItemDI>;
  checkedItems: Array<string | number>;
  onCheck: (id: string | number, checked: boolean) => void;
}

const FilterBoxes: React.FC<FilterBoxesPropsDI> = (props) => {
  const { t } = useTranslation();
  const maxNumItems = 4;
  const [range, setRange] = useState(maxNumItems);
  const slice = props.items.slice(0, range);

  const handleShowMore = () => {
    setRange(range + maxNumItems);
  };

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const id = e.target.name;
    const checked = e.target.checked;
    props.onCheck(id, checked);
  }; //

  return (
    <div className={style.search__main}>
      <div className={style.type}>
        {slice.map((item, index) => {
          return (
            <div key={item.id} className={style.type__item}>
              <div className={style.type__itemName}>
                <div className={style.type__itemCheckBox}>
                  <input
                    checked={props.checkedItems.includes(item.id.toString())}
                    tabIndex={0}
                    aria-label={
                      t("Accessibility-item") +
                      " " +
                      (index + 1) +
                      " " +
                      t("Accessibility-from") +
                      " " +
                      slice.length +
                      " " +
                      item.name
                    }
                    id={item.id + ""}
                    name={item.id + ""}
                    onChange={handleCheck}
                    type="checkbox"
                  />
                </div>
                <p className={style.type__itemText}>{item.name}</p>
              </div>
              <div className={style.type__itemCounter}>{item.count}</div>
            </div>
          );
        })}
        {props.items.length > range ? (
          <div
            role="button"
            aria-label={t("Lesson-search-more-types")}
            onClick={handleShowMore}
            className={style.type__more}
          >
            {t("Lesson-search-more-types")}
          </div>
        ) : null}
      </div>
    </div>
  );
};

// export default observer(LessonForm);
export default FilterBoxes;
